// Application state, moved to separate file for easier state management

export default {
  location: {
    lat: null,
    long: null,
  },
  layout: {
    navPos: "left", //top, bottom, left, right, false
    toolbar: "top", //top, bottom, false
    footer: true, //above, below, false
    boxed: false, //true, false
    roundedCorners: false, //true, false
    viewAnimation: "fade-top", // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
    theme: "theme-default",
  },
  branding: {},
  activeOperatorBranch: null,
  activeQueue: false,
  audioInputDeviceId: localStorage.getItem("audioInputDeviceId"),
  authTenants: [],
  collapseNav: false,
  hudMode: false,
  lastVMNumber: null,
  lastDashboardQueue: !!localStorage.getItem("lastDashboardQueue"),
  lastManagerDashboardLayout: localStorage.getItem(
    "lastManagerDashboardLayout"
  ),
  logged: !!localStorage.getItem("feathers-jwt"),
  networkTestVisible: false,
  operatorBranches: [],
  operatorMode: false,
  queueList: [],
  queueLoggedIn: false,
  queueMode: false,
  queuePaused: false,
  queuePausedReason: null,
  selectedQueue: {},
  selectedTenant: {},
  selectedTenantDIDs: [],
  softphoneEnabled: localStorage.getItem("softphoneEnabled") || true,
  softphoneLocked: false,
  softphoneTransfer: false,
  softphoneVisible: false,
  splashScreen: true,
  userDND: false,
  userHostServer: "",
  userStatus: "",
  voicemailCount: 0,
  userTimeOffset: 0,
  inboundRingVolume: localStorage.getItem("inboundRingVolume") || 1,
  outboundRingVolume: localStorage.getItem("outboundRingVolume") || 1,
  callWaitingVolume: localStorage.getItem("callWaitingVolume") || 1,
  whatsNewBadge: localStorage.getItem("whatsNewBadge") || "",
  incomingRingTone:
    localStorage.getItem("incomingRingTone") ||
    "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/10.mp3",
  dtmfStore: {},
  plantronicsEnabled: localStorage.getItem("plantronicsEnabled") || false,
  queueManagerAggregates: {},
  selectedQueueLayout: {},
  userQueueLayouts: [],
  qrcodeUrl: null,
};
